export const TITLE = "Trip Review";
export const SUBTITLE = "Review your trip before you Confirm and Book.";
export const BACK_TO_RESULTS = "Back to results";
